import React from "react";

export default function CampaignOffline() {
  return (
    <>
      <div className="grid grid_cols_4 grid_margin_bottom "></div>
      <div className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card flex justify_center align_center ">
        <h3 className="coming_soon">Coming Soon...</h3>
      </div>
    </>
  );
}
